export default __webpack_public_path__ + "static/media/078-seal.b39185bd.svg";